import { Injectable } from "@angular/core";
import { IFunciona } from "@edp-components/edp-card-widgets/edp-widget-funciona/funciona-service-type.model";
import { Contract } from "@edp-components/edp-contract/edp-contract.model";
import { ApiService } from "@edp-services/api.service";

@Injectable({providedIn: "root"})

export class FuncionaService {

    constructor(private apiService: ApiService) { }

    public contactsInAnalysis(contractId: string) {
        return this.apiService.callServicePostToCollection(`funciona.contactsInAnalysis`, { contractId });
    }

    public technicalAssistanceDetails(partnerNumber: number, accountNumber: string, funciona: IFunciona) {
        return this.apiService.callServicePostToCollection(
            `funciona.technicalAssistanceDetails`,
            { partnerNumber, accountNumber, funciona });
    }

    public getCheckupCards(contract: Contract) {
        return this.apiService.callServicePostToCollection(
            `funciona.getCheckupCards`,
            {
                contractId: contract.ContractId,
                productList: contract.Product
            }
        );
    }
}
